<script>
import { required } from "@vuelidate/validators";

import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import FormGroup from "@/components/molecules/form-group";
import Form from "@/components/molecules/form";
import FormInput from "@/components/molecules/form-input";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  name: "ListeDeCoursesRenommer",
  components: {
    Popin,
    Button,
    FormGroup,
    Form,
    FormInput,
    StateOverlay
  },
  props: {
    titre: {
      type: String,
      required: false,
      default: ""
    },
    ...formValidationProps()
  },
  emits: ["update"],
  setup(props) {
    const { v$, getState, getErrorMessage, checkValidation } =
      useFormValidation(props);
    return {
      v$,
      getState,
      getErrorMessage,
      checkValidation
    };
  },
  data() {
    return {
      model: {
        titre: ""
      }
    };
  },
  validations() {
    return {
      model: {
        titre: {
          required
        }
      }
    };
  },
  methods: {
    show() {
      this.model.titre = this.titre;
      this.v$.model.titre.$reset();
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    },
    save() {
      if (this.checkValidation(this.v$)) {
        this.$emit("update", this.model.titre);
      }
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    aria-label="Renommer votre liste"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <StateOverlay
      overlay
      :is-loading="state === 'loading'"
    >
      <div class="u-text-center">
        <h1 class="u-color-primary u-font-22 u-mb-md">
          Renommer votre liste
        </h1>
        <Form
          :error="error"
          @submit.prevent="save()"
        >
          <FormGroup
            class="u-mb-lg"
            center
            :state="getState(v$,'titre', 'model')"
          >
            <FormInput
              v-model.trim="model.titre"
              type="text"
              :state="getState(v$,'titre', 'model')"
            >
              Nom de la liste*
            </FormInput>
            <template #message>
              <p>
                {{ getErrorMessage("titre","Merci de nommer cette liste") }}
              </p>
            </template>
          </FormGroup>
          <Button
            variant="primary"
            radius="full"
            size="md"
            type="submit"
            value="Valider"
          />
        </Form>
      </div>
    </StateOverlay>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
